import React, { useState } from "react";
import CrudPage from "./pages/DynamicCrud/CrudPage";
import { useLocation } from "react-router-dom";
const DynamicInsertionMaster = () => {
  const location = useLocation();

  const payload = location.state?.payload;
  const [head, tableName] = payload.tableName.split(".");

  return (
    <div>
      {/* // <CrudPage tableName="t_7a" /> */}
      <CrudPage tableName={tableName} />
    </div>
  );
};
export default DynamicInsertionMaster;
